<template>
    <div>
        <div class='info-title'>
          {{targetObj.componentName === 'operate' ?'操作信息':'审批信息'}}
        </div>
        <div class="approval-out">
            <div class='no-data' v-if='!list || !list.length'>
            暂无{{targetObj.componentName === 'operate' ?'操作信息':'审批信息'}}
            </div>
            <ul class="approval-in" v-if='list && list.length'>
                <li v-for='(item, index) in list' :key="item.operateId">
                  <div class="approval-right-right operate-detail">
                    <div class="time"><span v-if='item.createTimeString'>{{item.createTimeString}}</span><span v-if='!item.createTimeString'>&nbsp;</span></div>
                    <div class="content" :id='"content"+index'>
                        <div class="namebox bolder">{{item.createName}}</div>
                        <div class="namebox">{{item.content}}</div>
                        <div v-if="item.remake">{{targetObj.componentName === 'operate' ?'操作日志':'审批日志'}}:{{item.remake}}</div>
                    </div>
                  </div>
                </li>
            </ul>
        </div>
        <div class="close-btn">
          <el-button size="large" @click="$emit('closeLog')">返回</el-button>
        </div>
    </div>
</template>
<script>
import Api from "@/api/foreign/foreign_cancellation";
export default {
    data(){
        return {
              operateLoading:false,
              list:[],
        }
    },
    props:{
        height: {
            type: Number,
            default: 500
        },
        targetObj:{
          type:Object
        },
        isSpeal:{
          type:Boolean
        },
        visible:{
          type:Boolean
        },
    },
    watch:{
      targetObj:{
        handler(newV,oldV){
          if(newV.isHandler){
            this.initData();
          }
        },
        immediate:true
      }
    },
    methods:{
      initData(){
        this.operateLoading = true;
        let obj = {destroyOrRenewalId:this.targetObj.destroyId}
        if(this.targetObj.componentName === 'operate'){
          let apiName = 'getOperateLogs'
          if(this.isSpeal){
            apiName = 'getExamineLogs'
          }
          Api[apiName](obj).then((res) => {
            this.list = res.data
            this.operateLoading = false;
          }).catch(() => {
            this.operateLoading = false;
          })
        }else{
          Api.getExamineLogs(obj).then((res) => {
            this.list = res.data;
            this.operateLoading = false;
          }).catch(() => {
            this.operateLoading = false;
          })
        }

      }
    }
}
</script>
<style lang="sass">
@import '../../foreign_Invitation_manage/style/log-detail.sass';
</style>
<style lang="scss" scoped>
  .close-btn {
    text-align: center;
    margin-top: 25px;
  }
  .approval-out {
    ul {
      .operate-detail {
        float: none !important;
      }
    }
  }
</style>
